import { Drawer } from 'antd';
import styled from 'react-emotion';
import { themeGet } from 'styled-system';

export const PadlessDrawer = styled(Drawer)` &&& {
  .ant-drawer-title {
    line-height: 14px;
  }
  
  .ant-drawer-wrapper-body, .ant-drawer-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .ant-drawer-body {
    min-height: 0;
  }

  .ant-drawer-content-wrapper {
    height: calc(100vh - ${themeGet('heights.navBarHeight')}) !important;

    #bktWrapper {
      height: calc(100% + 7px) !important;
    }
  }

  .ant-drawer-body,
  .ant-collapse-content-box {
    padding: 0;
  }

  /* Interesting is I need to use Odd rows to get even numbers of row in Bkt-grid. */
  .DCRPScenarioCompareSimilarGrid {
    .ReactVirtualized__Grid .bktGrid__OddRow {
      border-bottom: 1px dashed #777;
    }
  }
}`;
